import { useI18n } from "../i18n/I18nProvider";
import { useMoney } from "../lib/CurrencyProvider";

/**
 * The smaller price under the main one when prices are in dollars: "$ 604.941 con transferencia".
 * In pesos the main price is already the transfer one, and the Mercado Pago price shows only at checkout.
 */
export function TransferPrice({ price, priceArs }: { price: number; priceArs?: number | null }) {
  const { t } = useI18n();
  const second = useMoney().secondaryPrice(price, priceArs);
  if (!second || second.kind === "card" || (price <= 0 && !priceArs)) return null;
  return <p className="price-transfer">{t("product.transferPrice", { price: second.text })}</p>;
}
